export default __webpack_public_path__ + "static/media/08_DAIF_WHY_DELL_03.55463a68.mp4";